
    import {Component, Vue} from 'vue-property-decorator';
    @Component
    export default class Home extends Vue {
        title = "外部调用";
        url = ""
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)

        created(){
            const originToken = this.$store.state.originToken;
            const url = this.$route.params.url;
            this.url = "http://base.hebjlzy.com/?token="+originToken+"#/"+url+"#/";
        }
    }
